module.exports = __webpack_public_path__ + "img/bot-avatar.12c161e5.svg";